import "./workflow-new.scss"
import React, { SetStateAction, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleArrowLeft, faEllipsis } from "@fortawesome/free-solid-svg-icons"
import api, { CRM_API_URI } from "api";
import { useParams } from "react-router-dom";
import { ColumnType } from "types";

interface props{
    setActiveWorkflowNew:any,
    getWorkflow:any,
    deactivateWorkflow:any,
    columns:any,
    getCol:any,
    workFlow:any,
    setItemsFromBackendLogicallyLinked:any
    
}

function WorkflowNew({setActiveWorkflowNew,getWorkflow,deactivateWorkflow,columns,getCol,workFlow,setItemsFromBackendLogicallyLinked}:props) {
    const params: any = useParams();
    const [name,setName]=useState("");
    const [badColumns,setBadColumns]=useState<any[]>();
    const [isRunning,setIsRunning]=useState<boolean>(false);

    function delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
     }

    const createWordBinGroup=async ()=>{
        setIsRunning(true);
          await api.reactionLists.CreateGroup(params.reactionListId,name);
          let cols=await api.reactionLists.getWordflowDetails(workFlow.Id)
          //console.log(workFlow);
          setBadColumns(cols);
          //console.log(cols);
          
          

          let newCols=columns;
        
          if(cols){
            let NewColumns: ColumnType[]=[];
            cols.forEach(
               (item:ColumnType)=>{
                   if(item.IsDeleted==false){
                       item.Tickets=[];
                       NewColumns.push(item);
                   }
               } 
            )
            
           
        
                let list: any[] = [];
                NewColumns.forEach((col:any)=>{
                    let result:any[] = [];
                    api.reactionLists.getWorkflowCips(col.Id,"2020/01/01","2023/01/01",params.projectId).then((r)=>{
                        r.forEach((r:any)=>{
                            console.log(r);
                            list.push([r]);
                        })
                    });
                    
                   
                })
                let count=0;
            
               
                 
            await delay(1000);
               
            list.forEach((l)=>{
                NewColumns.forEach((c)=>{
                    
                    if(l.at(0).WorkflowGroupId==c.Id){
                        c.Tickets.push(l.at(0));
                    }
                })
            })
        
            getCol(NewColumns);
            console.log("here");
            console.log(NewColumns);
          }
        

          //newCols.push(badColumns);
          
          
         
          setActiveWorkflowNew(false);
          
    }


    

    const changeName = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setName(value);
    }


  return (
      <div className="new-workflow-container">
          <input onChange={changeName} placeholder="Workflow Group Name"></input>
          <div className="nw-btn-split">
                <button onClick={()=>setActiveWorkflowNew(false)}>Cancel</button>
                <button onClick={createWordBinGroup}>Create Group</button>
          </div>
      </div>
  )
}

export default WorkflowNew